(function () {
  function initTicker(ticker) {
    if (ticker.dataset.initiated) return;

    const inner = ticker.querySelector('.ticker-inner');
    if (!inner) return;

    ticker.dataset.initiated = "true";

    // Duplicate content for seamless loop
    inner.innerHTML += inner.innerHTML;

    let position = 0;
    const speed = parseFloat(ticker.dataset.speed) || 0.5;

    function animate() {
      position -= speed;

      if (Math.abs(position) >= inner.scrollHeight / 2) {
        position = 0;
      }

      inner.style.transform = `translateY(${position}px)`;
      requestAnimationFrame(animate);
    }

    animate();
  }

  function initAllTickers() {
    document.querySelectorAll('.ticker').forEach(initTicker);
  }

  // Init on load
  document.addEventListener('DOMContentLoaded', initAllTickers);

  // Optional: re-init for Shopify section reloads
  document.addEventListener('shopify:section:load', initAllTickers);
})();